"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.putContractAcceptTerms = exports.hasOnlyTrialContracts = exports.hasIndirectContract = exports.hasEnterpriseContract = exports.hasAllocationContract = exports.getTransformedContracts = exports.getIndirectContract = exports.getContractsNeedTermsAcceptance = exports.getContractList = void 0;
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2021 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

const data_model_list_1 = require("@pandora/data-model-list");

const react_data_source_jil_1 = require("@pandora/react-data-source-jil");

const Contract_1 = require("./Contract");
/**
 * @description Call JIL to get list of contracts
 *
 * @param contractListOptions Contract list options
 * @param jilFetchOptions JIL fetch options
 *
 * @returns JilModelList<Contract> instance that contains the list of contracts
 */


const getContractList = (contractListOptions, jilFetchOptions) => __awaiter(void 0, void 0, void 0, function* () {
  const jilFetch = react_data_source_jil_1.getJilFetch(jilFetchOptions);
  const response = yield react_data_source_jil_1.getOrganizationsContracts(jilFetch, contractListOptions);
  const jsonData = yield response.json();
  const items = exports.getTransformedContracts(contractListOptions.orgId, jsonData);
  return new data_model_list_1.JilModelList(Object.assign(Object.assign({}, contractListOptions), {
    headers: response.headers,
    items
  }));
});

exports.getContractList = getContractList;
/**
 * @description Get the list of contracts that needs their terms to be accepted
 * @param contractList JilModelList of Contracts
 * @returns List of Contracts that needs their terms to be accepted
 */

const getContractsNeedTermsAcceptance = contractList => {
  return contractList.items.filter(contract => {
    var _a;

    return (_a = contract.termsAcceptances) === null || _a === void 0 ? void 0 : _a.find(termsAcceptance => termsAcceptance.needToAcceptTerms());
  });
};

exports.getContractsNeedTermsAcceptance = getContractsNeedTermsAcceptance;
/**
 * @description Returns the first found indirect contract.
 * @param {ContractList} contractList - the contract list
 *
 * @returns {Contract} indirect contract, or undefined
 */

const getIndirectContract = contractList => {
  return contractList.items.find(item => item.isIndirectContract());
};

exports.getIndirectContract = getIndirectContract;
/**
 * @description generates a API response data transformer for the given OrgID
 *
 * @param {String} orgId - data from the API response
 * @param {Object} responseData - data from the API response
 *
 * @returns {Array} - ModelList transformer that converts API data into Contract models
 */

const getTransformedContracts = (orgId, responseData) => {
  return responseData.map(responseItem => new Contract_1.Contract(Object.assign(Object.assign({}, responseItem), {
    orgId
  })));
};

exports.getTransformedContracts = getTransformedContracts;
/**
 * @description Returns true if there is an allocation contract.
 * @param {ContractList} contractList - the contract list
 *
 * @returns {Boolean} true if this is an allocation contract.
 */

const hasAllocationContract = contractList => {
  return contractList.items.some(item => item.isModelAllocation());
};

exports.hasAllocationContract = hasAllocationContract;
/**
 * @description Returns true if there is an enterprise contract.
 * @param {ContractList} contractList - the contract list
 *
 * @returns {Boolean} true if this is an enterprise contract.
 */

const hasEnterpriseContract = contractList => {
  return contractList.items.some(item => item.isEnterpriseContract());
};

exports.hasEnterpriseContract = hasEnterpriseContract;
/**
 * @description Returns true if there is an indirect contract.
 * @param {ContractList} contractList - the contract list
 *
 * @returns {Boolean} true if this is an indirect contract.
 */

const hasIndirectContract = contractList => {
  return contractList.items.some(item => item.isIndirectContract());
};

exports.hasIndirectContract = hasIndirectContract;
/**
 * @description Returns true if there are only trial contracts in this list.
 * @param {ContractList} contractList - the contract list
 *
 * @returns {Boolean} true if there are only trial contracts in this list.
 */

const hasOnlyTrialContracts = contractList => {
  return contractList.items.length > 0 && contractList.items.every(item => item.isTrial());
};

exports.hasOnlyTrialContracts = hasOnlyTrialContracts;
/**
 * @description Accept terms and conditions for a contract
 * @param contractAcceptTermsOptions - Options for accepting contract terms
 * @param jilFetchOptions - Options for jilFetch
 * @returns Response object from jilFetch
 */

const putContractAcceptTerms = (contractAcceptTermsOptions, jilFetchOptions) => __awaiter(void 0, void 0, void 0, function* () {
  const jilFetch = react_data_source_jil_1.getJilFetch(jilFetchOptions);
  const {
    contract,
    requestInit
  } = contractAcceptTermsOptions;
  const options = {
    contractId: contract.id,
    orgId: contract.orgId,
    requestInit
  };
  const response = yield react_data_source_jil_1.putOrganizationContractAcceptTerms(jilFetch, options);
  return response;
});

exports.putContractAcceptTerms = putContractAcceptTerms;